const AbsoluteLightValues = Object.freeze({
    white: {
        base: {
            default: '#ffffff',
            action: '#ECECEC',
            active: '#ffffff',
            activeAction: '#ECECEC',
        },
        text: {
            default: '#000000',
            action: '#000000',
            active: '#000000',
            activeAction: '#000000',
        },
    },
    black: {
        base: {
            default: '#000000',
            action: '#313131',
            active: '#000000',
            activeAction: '#313131',
        },
        text: {
            default: '#ffffff',
            action: '#ffffff',
            active: '#ffffff',
            activeAction: '#ffffff',
        },
    },
});
const AbsoluteDarkValues = Object.freeze({
    white: {
        base: {
            default: '#ffffff',
            action: '#ECECEC',
            active: '#ffffff',
            activeAction: '#ECECEC',
        },
        text: {
            default: '#000000',
            action: '#000000',
            active: '#000000',
            activeAction: '#000000',
        },
    },
    black: {
        base: {
            default: '#000000',
            action: '#313131',
            active: '#000000',
            activeAction: '#313131',
        },
        text: {
            default: '#ffffff',
            action: '#ffffff',
            active: '#ffffff',
            activeAction: '#ffffff',
        },
    },
});

export { AbsoluteDarkValues, AbsoluteLightValues };
